import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAssetsThunk,
  createAssetThunk,
  updateAssetThunk,
  deleteAssetThunk,
} from "./fixedAssets.thunk";

const initialState = {
  assets: [],
  loading: false,
  error: null,
  total: 0,
  otherData: {
    totalValue: 0,
    appreciating: 0,
    depreciating: 0,
    fixed: 0,
  },
};

const fixedAssetsSlice = createSlice({
  name: "fixedAssets",
  initialState,
  reducers: {
    clearFixedAssetsState: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // GET ALL
      .addCase(fetchAssetsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAssetsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.assets = action.payload?.data || [];
        state.total = action.payload?.total || 0;
        state.otherData = action.payload?.otherData || {
          totalValue: 0,
          appreciating: 0,
          depreciating: 0,
          fixed: 0,
        };
      })
      .addCase(fetchAssetsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // CREATE
      .addCase(createAssetThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAssetThunk.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.data) {
          state.assets.unshift(action.payload.data);
          state.total += 1;
        }
      })
      .addCase(createAssetThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // UPDATE
      .addCase(updateAssetThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateAssetThunk.fulfilled, (state, action) => {
        state.loading = false;
        const updated = action.payload?.data;
        if (updated) {
          const index = state.assets.findIndex((item) => item._id === updated._id);
          if (index !== -1) state.assets[index] = updated;
        }
      })
      .addCase(updateAssetThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // DELETE
      .addCase(deleteAssetThunk.fulfilled, (state, action) => {
        const id = action.meta.arg;
        state.assets = state.assets.filter((item) => item._id !== id);
        state.total = Math.max(0, state.total - 1);
      });
  },
});

export const { clearFixedAssetsState } = fixedAssetsSlice.actions;

export default fixedAssetsSlice.reducer;
